import { number } from "../../config";

export const WORKFLOW_DEFAULT_VALUES = {
  active: true,
  showDescription: true,
  showAttachment: true,
  showSubChildTask: true,
  showComment: true,
  showTaskDescPopup: true,
  tags: [],
  tagIds: [],
  follower: [],
  taskName: "",
  dueDateDays: number.THREE,
  archiveDays: number.ONE,
  selectFirstStage: true,
  reminder: [],
  startFlowAfter: number.ZERO,
  isDefault: false,
  desc: "<p></p>",
  subtaskData: [],
  childtaskData: [],
  attachments: [],
  flowElementData: [],
  existingFlowElements: [],
  existingSubtask: [],
  existingChildtask: [],
  stages: [],
  simplifiedDetail: true,
  effort: number.ZERO,
  workflowReminders: [],
};

export const projectWorkflowKeyMap = {
  name: "WorkflowName",
  description: "WorkflowDescription",
  taskName: "TaskName",
  privacy: "WorkflowPrivacy",
  isActive: "IsActive",
  taskPriority: "TaskPriority",
  taskDueDateAfter: "TaskDueDateAfter",
  defaultAssignee: "DefaultAssignee",
  icon: "Icon",
};

export const workflowLabels = {
  WORKFLOW_DETAILS: "Workflow Details",
  EDIT_DESCRIPTION: "Edit Description",
  ALL: "All",
  MAIL_TEMPLATE: "Mail Template",
};
export const workflowQuote = {
  TASK_DETAILS_PANEL:
    "Task name, priority, and reminders will be configured based on the settings selected below for tasks created using this workflow",
  TAGS_PANEL: "The selected tags will be added to every task created using this workflow",
  FOLLOWERS_PANEL: "The selected followers will be added to every task created using this workflow",
  TIMESHEET_PANEL: "The expected efforts set the due date for every task created using this workflow",
  DESCRIPTION_PANEL: "The task description will be copied from the section below for each task created using this workflow",
  ATTACHMENTS_PANEL: "Attachments added here will be included in every task created using this workflow",
  SUB_TASK_CHILD_TASK_PANEL: "Sub-Tasks and Child Tasks added here will be included in every task created using this workflow",
  COMMENTS_PANEL: "If the comments toggle is enabled, the comments panel will be visible for every task created using this workflow",
  EMAIL_INTEGRATIONS: "Tasks can be auto-created for every email received",
  INTERNAL_FLOW_ELEMENTS: "Tasks will be automatically assigned to team members at each stage change for every task created using the workflow",
  EDIT_ACKNOWLEDGEMENT_TEMPLATE: "Edit acknowledgement Template",
  EDIT_SEND_TICKET_EMAIL_TEMPLATE: "Edit Response Email Template",
  EDIT_DEFAULT_PROMPT: "Edit Default Prompt for AI Insights",
  CUSTOMIZE_AI_INSIGHT_PROMPT: "Customize AI Prompt",
  EDIT_CHILD_TASK_DESCRIPTION: "Edit Child Task Description",
  ESCALATION_TASK_TOOLTIP: "Alerts trigger when tasks miss deadlines",
  TIMESHEET_INFO: "The expected efforts set the due date for every task associated with this workflow",
  DESCRIPTION_FOR_AI_CHATBOT: "Description for AI Chatbot",
  COMMENT_PANEL_ENABLE: "Ping panel is enabled for all tasks created",
  INFO_FOR_AI_CHATBOT: "Updates may take a few hours to appear in the chatbot",
  UPDATE_MESSAGE: "Changes saved successfully",
};

/**
 * Base configuration for attachment and linked task panels
 * The 'enabled' property is computed dynamically in components based on panelEnabled and workflow state
 * @author Muskan Thakur
 */
export const panelConfig = {
  attachments: {
    fieldName: 'showAttachments',
    panelKey: 'attachments',
    featureId: number.SIX,
  },
  linkedTasks: {
    fieldName: 'showChildSubTasks',
    panelKey: 'linkedTasks',
    featureId: number.SEVEN,
  },
};